
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/repository",
      function () {
        return require("private-next-pages/repository/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/repository"])
      });
    }
  